export default __webpack_public_path__ + "static/media/register-dark.0e4dbf53.svg";